import { Box, Link, styled, SxProps, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioFonts } from "../../../../configuration/themeSettings";

export const RowBox = styled(Box, { label: "AppProfilePopup-RowBox" })(
  ({ theme: theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: StyleguideSavioFonts.bold,
    textTransform: "uppercase",
    padding: "7px 0 7px 0",
    display: "flex",
    borderBottom: "1px solid " + theme.palette.myGray.dark,
    "a":{display: 'flex', alignItems: 'center', fontSize: 14,
      
    },
    "svg":{
      fontSize: 25,
      marginRight: 10,
    }
  })
);

export const LinkStyled = styled(Link, { label: "AppProfilePopup-Link-Styled" })(
  ({ theme: theme }) => ({
    'span':{paddingTop:2,},
   
    "&:hover":{
      color: MiscSavio.hoverColor,
    }
  })
);

export const useAppProfilePopupClasses = () => {
  const theme = useTheme();
  const classes = {
    appBar: {} as SxProps,
    inputLabel: {
      mt: 2,
    } as SxProps,
    select: {
      mt: 2,
      width: "100%",
    } as SxProps,
  };
  return classes;
};
